
import { Navigate } from "react-router-dom";
import useAuthentication from "../hooks/auth/UseAuthentification";

const ProtectedRoute = ({ children }) => {
  const auth = useAuthentication();
  // If no accessToken, redirect to the login screen
  if (!auth.accessToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
